// Slice E8 — herald discovery logic, kept JSX-free and side-effect-free so
// the rehearsal can drive it in node directly. The component owns all I/O
// (localStorage, fetch, navigation); this module owns the decisions.

// Per-user key: the mark survives logout/login on a device without leaking
// across users sharing a browser.
export const heraldKey = (userId) => `gvc_herald_hwm:${userId}`;

// A stored mark is only trusted if it parses to a real timestamp; anything
// else (absent, corrupted) means "first run": the caller initializes to NOW
// and stays SILENT — the backlog is never heralded.
export const parseMark = (stored) => {
  if (typeof stored !== 'string' || stored === '') return null;
  const t = Date.parse(stored);
  return Number.isNaN(t) ? null : stored;
};

// rows: the notifications list (any order); hwm: ISO string mark.
// STRICTLY newer than the mark counts — a row exactly AT the mark was the
// one that set it, and must never re-herald.
export const discoverNew = (rows, hwm) => {
  const mark = Date.parse(hwm);
  const fresh = (rows || []).filter(
    (r) => r && r.created_at && Date.parse(r.created_at) > mark
  );
  if (fresh.length === 0) return { count: 0, newest: null, nextHwm: hwm };
  let newest = fresh[0];
  for (const r of fresh) {
    if (Date.parse(r.created_at) > Date.parse(newest.created_at)) newest = r;
  }
  return { count: fresh.length, newest, nextHwm: newest.created_at };
};

// One bubble per discovery, never a parade: singles speak, bursts aggregate.
export const bubbleCopy = (count, newest) =>
  count === 1
    ? (newest.title || 'New notification')
    : `${count} new notifications — latest: ${newest.title || 'notification'}`;
